//@ts-nocheck
import { Card, CardBody, Col } from "reactstrap";
import CommonCardHeader from "../../../Common/CommonCardHeader";
import Rating from "react-rating";
import { FontawesomeThumbsUpDownRating } from "../../../Constant";
import { THUMBS_RATING } from "../../../Data/Bonus Ui/Rating";

const ThumbsUp = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <CommonCardHeader title={FontawesomeThumbsUpDownRating} span={THUMBS_RATING} />
        <CardBody>
          <div className="rating-container">
            <Rating emptySymbol="fa fa-thumbs-down fa-2x" fullSymbol="fa fa-thumbs-up fa-2x" />
          </div>
        </CardBody>
      </Card>
    </Col>
  );
};

export default ThumbsUp;
